import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M26.667 4h-1.334V1.333h-2.666V4H9.333V1.333H6.667V4H5.333a2.675 2.675 0 0 0-2.666 2.667V28c0 1.467 1.2 2.667 2.666 2.667h21.334c1.466 0 2.666-1.2 2.666-2.667V6.667C29.333 5.2 28.133 4 26.667 4m0 24H5.333V10.667h21.334z"
    }, null, -1)
  ])))
}
export default { render: render }